// extracted by css-extract-rspack-plugin
export default {"UpsellBigCardComponent":"Au9n8"};